import * as actiontypes from './actionTypes';


export const setLanguage =(lang)=>{
    return (dispatch )=>{
        dispatch({type:actiontypes.SET_LANGUAGE, lang:lang});

    }
}



// WEBPACK FOOTER //
// ./src/actions/optionsActions.js